<template>

<div class="col-12">
<label class="text-xs" :class="completion_class">{{labeltext}}
<span class="material-icons md-26 ml-3 text-yellow-400" v-if="data.submission_note_required && !data.completion"
v-tooltip.right="{ value: $store.state.languages.lang_phrases.gerekli, disabled: false,class: 'custom-top-tooltip' }"
>
emergency
</span>
</label>

<template v-if="data.read_only_state">
<div>
<p v-html="thevalue" ></p>
</div>
</template>
<template v-if="!data.read_only_state">
  
    <Textarea 
    v-if="editing"
    ref="textareaedit"
    v-model="inputdata" 
    :autoResize="true" rows="3" 
    cols="30"  
    class="w-full p-inputtext-sm mb-3" 
    :class="{'p-invalid':has_error }"  
    v-click-away="fieldChanged" 
    :disabled="disabled" 
     />
    <div v-if="!editing" class="submission_note_area" :class="disabledclass" @click="edit" v-html="thevalue">
      
    </div>
  
</template>


<!--<small  class="p-error pt-2" v-if="has_error"> {{char_length_err_message}}</small>-->
</div>
</template>

<script>
export default {

  name: 'InputfieldNote',
  props:["data"],
  watch:{
    propdata(newval)
    {
      this.inputdata = newval
    },
  },
  data () {
    return {
    	inputdata:null,
      editing:false,
    }
  },
  computed:{
    disabled()
    {
      if(this.data.is_nulled)
      {
        return true
      }
      return false
    },
    disabledclass()
    {
      if(this.data.is_nulled)
      {
        return "disabledclass"
      }
      return ""
    },
    thevalue()
      {
        if(this.inputdata)
        {
          let text = this.inputdata.replace(/\n\r?/g, '<br />');
          return text
        }
        return null
      },
     propdata()
    {
      if(this.data.submissions.length>0)
      {
        let propdata = this.data.submissions[0].submission_note
        return propdata
      }
    },
    completion_class()
    {
      if(this.data.completion)
      {
        return "quiz_label_completed"
      }
      else
      {
        return "quiz_label"
      }
    },
    labeltext()
    {
      if(this.getTheTranslation(this.data,"submission_note"))
      {
        return this.getTheTranslation(this.data,"submission_note")
      }
      return this.$store.state.languages.lang_phrases.soru_aciklamasi
    },
    has_error()
    {
      if(this.data.submissions.length && this.data.submission_note_required && !this.data.submissions[0].submission_note)
      {
        return true
      }
      else
      {
        return false
      }
    },
  },
  mounted()
  {
  	
  	if(this.data.submissions.length>0)
  	{
  		this.inputdata = this.data.submissions[0].submission_note
  	}
  },
  methods: {
    edit()
    {
      if(this.disabled)
      {
        return false
      }
      this.editing=true
      setTimeout(()=>{
        this.$refs.textareaedit.$el.focus();
      })
    },
  	fieldChanged()
  	{
      this.editing=false
      this.submitInputData()
      return
      this.char_length_err = false
      this.char_length_err_message = null
      this.$store.dispatch('evaluation/setActiveInputfield',this.data) 
  		clearInterval(this.intervalobj);
  		this.intervalobj = setInterval(()=>{
  			this.submitInputData()
  		},4000)
  	},
  	submitInputData()
  	{
  		//clearInterval(this.intervalobj);
  		let formdata = new FormData()
  		formdata.append("submission_note",this.inputdata)
  		formdata.append("flowsupplier_id",this.$store.state.evaluation.evaluation.uuid)
      this.$store.dispatch('evaluation/setInputfieldsUpdating',true)
  		//return false
  		this.generalSubmission(formdata,"audit/submit_inputfield_submission_note/"+this.data.id,this.aftersubmitInputData)
  	},
  }
};
</script>

<style lang="css" scoped>
  .submission_note_area{
    width: 100;
    height: 64px;
    border-radius: 3px;
    border: 1px solid #aaa;
    padding: 0.4375rem 0.4375rem;
    font-size: 0.9rem;
    color: #aaa;
    margin-bottom: 19px;
    overflow: hidden;
  }
  .submission_note_area:hover{
    border-color: #352f8d;
    color: #222;
  }
  .disabledclass{
    background-color: rgba(0, 0, 0, 0.2);
  }
  .disabledclass:hover{
    border-color:#aaa;
  }
</style>